import { render, staticRenderFns } from "./relatorioCadTomadorPaisagem.vue?vue&type=template&id=73bb0124"
import script from "./relatorioCadTomadorPaisagem.vue?vue&type=script&lang=js"
export * from "./relatorioCadTomadorPaisagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports